import React from 'react';
import { AlertTriangle, CheckCircle, ChevronRight } from 'lucide-react';
import { ABLE_COLORS } from '../../constants';

/**
 * ExpiringCardWidget - Shows items expiring soon
 * Priority 2: Prevent food waste
 */
export default function ExpiringCardWidget({ 
  stockedItems = [], 
  onNavigate 
}) {
  // Count items expiring within 3 days
  const now = new Date();
  const threeDaysFromNow = new Date(now.getTime() + 3 * 24 * 60 * 60 * 1000);
  
  const expiringItems = stockedItems.filter(item => {
    if (!item.expiryDate) return false;
    const expiry = new Date(item.expiryDate);
    return expiry <= threeDaysFromNow && expiry >= now;
  });
  
  const expiredItems = stockedItems.filter(item => {
    if (!item.expiryDate) return false;
    const expiry = new Date(item.expiryDate);
    return expiry < now;
  });
  
  // Determine display
  let statusText, statusColor, bgColor, iconColor;
  let Icon = CheckCircle;
  
  if (expiredItems.length > 0) {
    statusText = `${expiredItems.length} expired`;
    statusColor = '#DC2626';
    bgColor = '#FEE2E2';
    iconColor = '#DC2626';
    Icon = AlertTriangle;
  } else if (expiringItems.length > 0) {
    statusText = `${expiringItems.length} expiring soon`;
    statusColor = '#D97706';
    bgColor = '#FEF3C7';
    iconColor = '#D97706';
    Icon = AlertTriangle;
  } else {
    statusText = "All fresh";
    statusColor = '#059669';
    bgColor = '#ECFDF5';
    iconColor = '#059669';
  }

  return (
    <button
      onClick={() => onNavigate && onNavigate('pantry')}
      style={{
        width: '100%',
        padding: '20px',
        background: ABLE_COLORS.neutral,
        border: 'none',
        borderRadius: ABLE_COLORS.cardRadius,
        boxShadow: ABLE_COLORS.cardShadow,
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        transition: 'all 0.15s ease',
        textAlign: 'left',
      }}
    >
      {/* Icon */}
      <div style={{
        width: '40px',
        height: '40px',
        borderRadius: '10px',
        background: bgColor,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
      }}>
        <Icon size={20} color={iconColor} />
      </div>
      
      {/* Content */}
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{
          fontSize: '16px',
          fontWeight: 700,
          color: ABLE_COLORS.textPrimary,
          marginBottom: '4px',
        }}>
          Freshness
        </div>
        <div style={{
          fontSize: '13px',
          fontWeight: 400,
          color: statusColor,
        }}>
          {statusText}
        </div>
      </div>
      
      {/* Arrow */}
      <ChevronRight size={18} color={ABLE_COLORS.textMuted} style={{ flexShrink: 0 }} />
    </button>
  );
}
